import {SovkombankLogo} from '../../../../assets/images';
import {Screens} from '../../../../shared/routing';

export const sovkomInitialData = {
  services: {
    [Screens.TransportService]: {
      cardTitle: 'Транспортное приложение',
      cardBody: 'Используется  в качестве электронного проездного билета',

      financial: {
        descriptionDesktop: `Единая карта жителя Мурманской области позволяет оплачивать проезд в общественном транспорте максимально удобно и быстро — в одно касание.`,
        descriptionMobile:
          'Единая карта Жителя Мурманской области позволяет оплачивать проезд в общественном транспорте максимально удобно и быстро — в одно касание.',
        featureListMarkdown: `* Транспортное приложение работает на территории Мурманской области на всех регулярных городских и пригородных маршрутах, кроме маршрутных такси.
* Единая карта жителя Мурманской области, выпускаемая Совкомбанком, сочетает в себе проездной билет (оплата за каждую поездку осуществляется с транспортного приложения) и банковское приложение (стоимость поездки списывается с основного банковского счета).
* ЕКЖ МО позволит сэкономить на проезде: стоимость поездки в наземном транспорте Мурманска составляет 26 рублей.`,
      },

      nonFinancial: {
        eCardReplenishmentTipsHtml:
          '<div class="text-normal">Пополнить ЕКЖ МО можно онлайн с карты любого банка. Для этого необходимо воспользоваться сервисом отложенного пополнения в разделе "<a class="text-normal" href="#">Пополнение транспортного приложения</a>". Подробнее о правилах пополнения можно узнать на <a class="text-normal" href="#">сайте</a>.</div>',
        eCardFeaturesHtml: `* Транспортное приложение работает на территории Мурманской области на всех регулярных городских и пригородных маршрутах, кроме маршрутных такси.
* С помощью Единой карты жителя Мурманской области держатели могут произвести расчет в паркоматах Мурманска.
* Экономия при оплате проезда в транспорте Мурманска составляет 2,4 и более рублей в зависимости от выбранного общегражданского [тарифа](http://example.com).
* Единая карта Жителя Мурманской области сделана из высококачественного пластика ПВХ, который защищает чип. При бережном использовании карта будет исправно работать до 10 лет.
        `,

        eCardReplenishmentLink: 'https://карта51.рф/replenishment/',
        eCardSupportPhone: '88002006005',
        descriptionDesktop:
          'Единая карта жителя Мурманской области позволяет оплачивать проезд в общественном транспорте максимально удобно и быстро - в одно касание.',
        descriptionMobile:
          'С более подробной информацией о транспортном приложении Вы можете ознакомиться в разделе <a class="text-normal" href="#">Поддержка</a>.',
      },
    },
    [Screens.BankingService]: {
      cardTitle: 'Банковские сервисы',
      cardBody: 'Позволяет получать скидки, бонусы и специальные предложения',
      descriptionMarkdown: `Единая карта жителя Мурманской области является полноценной банковской картой с дополнительными сервисами. Держатель ЕКЖ МО может оплачивать товары и услуги, получать денежные переводы, оформить/перенести перевод на счет карты заработной платы, пенсий, пособий, стипендий и других выплат. При этом вы всегда будете в курсе всех операций по карте - информация доступна держателю в личном кабинете.
&nbsp;
Для держателей Единой карты жителя Мурманской области актуальны те же правила безопасности, что и для держателей обычных банковских карт. При утере или краже карты необходимо незамедлительно обратиться в банк для блокировки, после чего карту можно будет перевыпустить. Держателям нефинансовых карт следует обращаться к оператору Единой карты жителя Мурманской области.
* Получайте на карту социальные выплаты и денежные переводы
* Всегда будьте в курсе своих финансовых операций
* Получайте кэшбек и спецпредложения от платежной системы «Мир»
* Оплачивайте товары и услуги
`,
      bankPhone: '88001000006',
      bankWebsite: 'https://sovcombank.ru',
      bankEntryLink: 'https://sovcombank.ru',
      logoUrl: SovkombankLogo,
    },
    [Screens.PrivilegesService]: {
      cardTitle: 'Мои льготы',
      cardBody: 'Всегда будете в курсе предоставленных льгот и пособий',
      descriptionMarkdown: `Единая карта жителя Мурманской области является полноценной банковской картой с дополнительными сервисами. Держатель ЕКЖ МО может оплачивать товары и услуги, получать денежные переводы, оформить/перенести перевод на счет карты заработной платы, пенсий, пособий, стипендий и других выплат. При этом вы всегда будете в курсе всех операций по карте - информация доступна держателю в личном кабинете.`,
    },
    [Screens.LoyaltyProgram]: {
      cardTitle: 'Программа лояльности',
      cardBody: 'Позволяет получать скидки, бонусы и специальные предложения',
      descriptionMarkdown: `Это самый простой, распространенный, старомодный и эффективный вид программ лояльности. Дисконтные программы могут быть простыми или накопительными. Как правило, дисконтная программа помогает клиенту определиться с местом покупки, при условии, что решение о покупке уже было принято.
&nbsp;
**Вы получите**
* Дисконтные программы
* Накопительная система
* Скидки у партнеров
* Оплата баллами`,
    },
    [Screens.VolunteersService]: {
      cardTitle: 'Волонтерство',
      cardBody: 'Будь в центре самых добрых событий',
      descriptionMarkdown: 'Описание секции волонтеров',
    },
  },

  support: {
    descriptionMobileMarkdown: `##### Уважаемые держатели Единой карты жителя Мурманской области!
По всем вопросам получения и использования карты обращайтесь на Горячую линию Государственной информационной системы «Единой карты жителя»
&nbsp;
По горячей линии можно узнать информацию о балансе, условиях обслуживания пластиковых карт, как оформить кредит или уточнить информацию по действующему кредиту, по другим услугам банка, адресах и режиме работы подразделений банка. Горячая линия работает круглосуточно.`,

    descriptionDesktopMarkdown: `##### Уважаемые держатели Единой карты жителя Мурманской области!
* Узнать больше о ЕКЖ МО, порядке ее обслуживания и полезных сервисах Вы можете, позвонив на Горячую линию “Единой карты жителя”

* Вопросы, связанные с банковским обслуживанием, Вы можете задать по телефону Горячей линии банка-соэмитента`,
  },

  aboutApplication:
    'Единая карта жителя Мурманской области является полноценной банковской картой с дополнительными сервисами. Держатель ЕКЖ может оплачивать товары и услуги, получать денежные переводы, оформить/перенести перевод на  счет карты заработной платы, пенсий, пособий, стипендий и других выплат. При этом вы всегжа будете в курсе всех операций по карте - информация доступна держателю в личном кабинете.',

  polls: {
    surveyDescription:
      'Единая карта жителя Мурманской области является полноценной банковской картой с дополнительными сервисами. Держатель ЕКЖ может оплачивать товары и услуги, получать денежные переводы, оформить/перенести перевод на счет карты заработной платы, пенсий, пособий, стипендий и других выплат. При этом вы всегда будете в курсе всех операций по карте - информация доступна держателю в личном кабинете.',

    voteDescription:
      'Единая карта жителя Мурманской области является полноценной банковской картой с дополнительными сервисами. Держатель ЕКЖ может оплачивать товары и услуги, получать денежные переводы, оформить/перенести перевод на счет карты заработной платы, пенсий, пособий, стипендий и других выплат. При этом вы всегда будете в курсе всех операций по карте - информация доступна держателю в личном кабинете.',

    noSurveysOnMainPage: 'Нет действующих опросов',
    noVotesOnMainPage: 'Нет действующих голосований',
    noActiveSurveys: 'Нет действующих опросов',
    noActiveVotes: 'Нет действующих голосований',
    noCompletedSurveys: 'Нет прошедших опросов',
    noCompletedVotes: 'Нет прошедших голосований',
  },

  eskmoContacts: {
    supportPhone: '88002006005',
    website: 'https://stage-murmansk.eskso.ru/',
    socialPhone: '88003008100',
  },

  ekartaContacts: {
    website: 'http://карта51.рф',
  },

  footer: {
    copyright: '© 2022-2023. Разработано в Министерстве цифрового развития Мурманской области',
    socials: {
      facebook: '',
      instagram: '',
      vk: 'https://vk.com/karta51',
      ok: '',
    },
    stores: {
      appStore:
        'https://apps.apple.com/ru/app/%D0%B5%D0%B4%D0%B8%D0%BD%D0%B0%D1%8F-%D0%BA%D0%B0%D1%80%D1%82%D0%B0-%D0%B6%D0%B8%D1%82%D0%B5%D0%BB%D1%8F/id1643645370',
      appGallery: 'https://appgallery.huawei.com/app/C106907289',
      googlePlay: 'https://play.google.com/store/apps/details?id=com.eskmo',
    },
    telephones: {
      hotlineText: 'Горячая линия',
      unionNumberText: 'Единый социальный телефон (по вопросам льгот)',
    },
  },

  docs: {
    politics: 'https://stage-murmansk.eskso.ru/privacy-policy/',
    agreement:
      'https://stage-murmansk.eskso.ru/documents/%D0%A1%D0%BE%D0%B3%D0%BB%D0%B0%D1%81%D0%B8%D0%B5%20%D0%BF%D0%BE%D1%81%D0%B5%D1%82%D0%B8%D1%82%D0%B5%D0%BB%D1%8F%20%D1%81%D0%B0%D0%B9%D1%82%D0%B0%20%D0%BD%D0%B0%20%D0%BE%D0%B1%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BA%D1%83%20%D0%9F%D0%94%D0%9D.pdf',
  },

  cardBlocking: {
    blockMessage:
      'Если у вас возникли подозрения на мошеннические действия в отношении вашей карты, вы можете заблокировать ее. И обратиться в отделения пункта выдачи для перевыпуска.',
    unblockMessage:
      'Для перевыпуска карты вам необходимо обратиться в ближайший центр выпуска или по телефону горячей линии.',
  },

  news: {
    noNewsInSelectedPeriod: 'За выбранный период новостей не найдено',
  },
};
